import { Label } from 'src/components/label';
import { SvgColor } from 'src/components/svg-color';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor width="100%" height="100%" src={`/assets/icons/navbar/${name}.svg`} />
);

const iconify_icon = (name: string) => (
  <Iconify width="100%" height="100%" icon={name} sx={{ color: ''}}/>
);

export const navData = [
  {
    title: 'Dashboard',
    path: '/',
    icon: iconify_icon('tabler:home'),
  },
  { 
    title: 'Calendar (Soon)',
    path: '/calendar',
    icon: iconify_icon('solar:calendar-line-duotone'),
  },
  { 
    title: 'Notes (Soon)',
    path: '/notes',
    icon: iconify_icon('solar:notes-line-duotone'),
  },
  { 
    title: 'Noto Study AI (Soon)',
    path: '/semestera-ai',
    icon: iconify_icon('noto-v1:owl'),
  },
  // {
  //   title: 'Calendar',
  //   path: '/calendar',
  //   icon: icon('ic-user'),
  // },
  // {
  //   title: 'Product',
  //   path: '/products',
  //   icon: icon('ic-cart'),
  //   info: (
  //     <Label color="error" variant="inverted">
  //       +3
  //     </Label>
  //   ),
  // },
  // {
  //   title: 'Blog',
  //   path: '/blog',
  //   icon: icon('ic-blog'),
  // },
  // {
  //   title: 'Sign in',
  //   path: '/sign-in',
  //   icon: icon('ic-lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic-disabled'),
  // },
];
